import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"color":"red"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "zhanwei4" }, null, -1)),
    _cache[14] || (_cache[14] = _createElementVNode("h1", { class: "title" }, "时间积分", -1)),
    _createVNode(_component_el_form, {
      model: _ctx.form,
      "label-width": "auto",
      "label-position": "top",
      style: {"max-width":"1000px","margin-left":"20px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, { gutter: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              xs: 24,
              sm: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "游戏标准时长（分钟）" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "number",
                      clearable: "",
                      modelValue: _ctx.form.gameTime,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.gameTime) = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              xs: 24,
              sm: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "超时扣分" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "number",
                      clearable: "",
                      modelValue: _ctx.form.timeoutDeducted,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.timeoutDeducted) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, { gutter: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              xs: 24,
              sm: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "满分" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "number",
                      clearable: "",
                      modelValue: _ctx.form.fullMarks,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.fullMarks) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              xs: 24,
              sm: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "多长时间内过关满分（分钟）" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "number",
                      clearable: "",
                      modelValue: _ctx.form.parlayTime,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.parlayTime) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, { gutter: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              xs: 24,
              sm: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "关卡积分" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "number",
                      clearable: "",
                      modelValue: _ctx.form.levelPoints,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.levelPoints) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              xs: 24,
              sm: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "每次答错积分" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "number",
                      clearable: "",
                      modelValue: _ctx.form.incorrectAnswer,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.incorrectAnswer) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, { gutter: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              xs: 24,
              sm: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "关卡数量" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "number",
                      clearable: "",
                      modelValue: _ctx.form.numberLevel,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.numberLevel) = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              xs: 24,
              sm: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "使用提示扣分" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "number",
                      clearable: "",
                      modelValue: _ctx.form.promptsDeduct,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.promptsDeduct) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, { gutter: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              xs: 24,
              sm: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "跳过过关扣分" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "number",
                      clearable: "",
                      modelValue: _ctx.form.skippingParlay,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.skippingParlay) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              xs: 24,
              sm: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "使用地点求救扣分" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "number",
                      clearable: "",
                      modelValue: _ctx.form.sosPoints,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.sosPoints) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, { gutter: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { xs: 24 }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [
                _createElementVNode("p", null, "游戏最高得分", -1)
              ])),
              _: 1
            }),
            _createVNode(_component_el_col, { xs: 24 }, {
              default: _withCtx(() => _cache[11] || (_cache[11] = [
                _createElementVNode("p", null, "时间分数(满分) + 关卡积分 * 关卡数=游戏最高得分", -1)
              ])),
              _: 1
            }),
            _createVNode(_component_el_col, { xs: 24 }, {
              default: _withCtx(() => [
                _createElementVNode("p", null, [
                  _createTextVNode(_toDisplayString(_ctx.form.fullMarks) + " + " + _toDisplayString(_ctx.form.numberLevel) + " x " + _toDisplayString(_ctx.form.levelPoints) + " = ", 1),
                  _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.totalPoint), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { xs: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  style: {"background":"#4f4f4f","color":"#fff","margin-top":"20px"},
                  size: "large",
                  onClick: _ctx.saveSettings
                }, {
                  default: _withCtx(() => _cache[12] || (_cache[12] = [
                    _createTextVNode("保存")
                  ])),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "zhanwei3" }, null, -1))
  ], 64))
}